import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../../../../components/forms/Checkbox';

interface ShowInactiveToggleProps {
  count: number;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

// Inactive entries are hidden by default; nothing to toggle when there are none.
export const ShowInactiveToggle: React.FC<ShowInactiveToggleProps> = ({
  count,
  checked,
  onChange,
}) => {
  const { t } = useTranslation();
  if (count === 0) return null;
  return (
    <Checkbox
      label={t('schedulingAdmin.showInactive', { count })}
      checked={checked}
      onChange={e => onChange(e.target.checked)}
    />
  );
};
